"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RDPStreamEvent = exports.DEFAULT_RDP_STREAMING_CONNECTION_NAME = void 0;
const item_stream_1 = require("./item-stream");
exports.DEFAULT_RDP_STREAMING_CONNECTION_NAME = 'streaming/quantitative-analytics/financial-contracts';
const Ack = 'Ack';
const Update = 'Update';
const Response = 'Response';
const Alarm = 'Alarm';
exports.RDPStreamEvent = Object.assign(Object.assign({}, item_stream_1.ItemStreamEvent), { Ack,
    Response,
    Update,
    Alarm });
